import { render, staticRenderFns } from "./FarmPageHeader.vue?vue&type=template&id=736140fc&scoped=true&"
import script from "./FarmPageHeader.vue?vue&type=script&lang=ts&"
export * from "./FarmPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FarmPageHeader.vue?vue&type=style&index=0&id=736140fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736140fc",
  null
  
)

export default component.exports